module.exports = __webpack_public_path__ + "static/media/patrol(29).459e6387.PNG";